module.exports = __webpack_public_path__ + "static/media/Group 9998.4355042c.svg";